import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required } from '../../../utilities/validators'
import Loader from '../../Loader/Loader'

const DeactivateAccountForm = ({ submitting, handleSubmit, onCancel }) => (
  <div>
    <h4 id="deactivate-heading">
      <FormattedMessage id="page.myAccountPage.deactivate.title" />
    </h4>
    <p>
      <FormattedMessage id="page.myAccountPage.deactivate.description" />
    </p>
    <form onSubmit={handleSubmit} method="post" aria-labelledby="deactivate-heading">
      <div disabled={submitting}>
        <div className="sr-only">Account deactivation form</div>
        <div className="row form-group">
          <Field
            component={renderField}
            dark
            validate={[required]}
            type="password"
            password
            name="password"
            label="global.label.password"
            containerclass="col-md-12"
            inputType="input"
          />
        </div>
      </div>
      <div className="w-100">
        <div className="row">
          <div className="col-6">
            <Button
              block
              outline
              color="light"
              onClick={onCancel}
              aria-label="Cancel account deactivation"
            >
              <FormattedMessage id="global.label.cancel" />
            </Button>
          </div>
          <div className="col-6">
            {submitting ? (
              <Loader aria-label="Processing account deactivation" />
            ) : (
              <Button
                block
                outline
                color="danger"
                type="submit"
                name="deactivateAccountFormSubmitBtn"
                aria-label="Confirm account deactivation"
                aria-disabled={submitting}
              >
                <FormattedMessage id="global.label.deactivate" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </form>
  </div>
)

DeactivateAccountForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
}

export default reduxForm({
  form: 'deactivateAccount',
})(DeactivateAccountForm)
